@if (isKontrakt() && !kontrakt.isSkogsvardFPVKontrakt) {
  <rask-icon class="kontrakt-status-icon" icon="fal fa-file-contract" popoverContainer="body"
    popoverClass="kontrakt-status-icon-popup"
    [ngClass]="isKontraktVacsValid() ? 'valid' : 'invalid'">
    <div class="body">
      <h3 class="popover-header">VACS</h3>
      <ul class="hints fa-ul">
        <li class="hint"><i class="fas fa-circle kontraktvacs-status-icon fa-li"
        [ngClass]="isKontraktVacsValid() ? 'valid' : 'invalid'"></i>{{ getVacsStatusText() }}</li>
      </ul>
    </div>
  </rask-icon>
}

@if (hasDrivningspunkter()) {
  <rask-icon class="kontrakt-status-icon" popoverContainer="body"
    popoverClass="kontrakt-status-icon-popup"
    [ngClass]="isAllDrivningspunkterValid() ? 'valid' : 'invalid'"
    icon="fas fa-map-marker-alt">
    <div class="body">
      <h3 class="popover-header">Drivningspunkter</h3>
      <div class="drivningspunkter">
        <div>
          <span [ngClass]="isLarmkoordinatValid() ? 'valid' : 'invalid'"
            class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isLarmkoordinatValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <span class="drivningspunkt-text">Minst en larmkoordinat</span>
        </div>
        <div>
          <span [ngClass]="isKojplatsValid() ? 'valid' : 'invalid'"
            class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isKojplatsValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <span class="drivningspunkt-text">Minst en kojplats</span>
        </div>
        <div>
          <span [ngClass]="isAvlaggValid() ? 'valid' : 'invalid'" class="fa-stack fa-1x drivningspunkt">
            <i class="fas fa-circle fa-stack-2x"></i>
            @if (isAvlaggValid()) {
              <i class="fas fa-check fa-stack-1x fa-inverse"></i>
            }
          </span>
          <div class="drivningspunkt-text">Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass</div>
        </div>
      </div>
    </div>
  </rask-icon>
}